import { formatCurrency } from "@/common/utils/formatters";
import { AnpPricePoint } from "../types/anpReports.type";
import { formatGeoName } from "../utils/formatGeoName";

export class AnpPricesTransformer {
  static tableTransformer(_geoType: AnpPricePoint['geo_type']) {
    return (prices: AnpPricePoint[]) => (
      prices.map((price) => {
        const averagePriceValue =
          price.average_resale_price === null
            || price.average_resale_price === undefined
            || price.average_resale_price === ''
            ? undefined
            : Number(price.average_resale_price);

        const minPriceValue =
          price.min_resale_price === null
            || price.min_resale_price === undefined
            || price.min_resale_price === ''
            ? undefined
            : Number(price.min_resale_price);

        const maxPriceValue =
          price.max_resale_price === null
            || price.max_resale_price === undefined
            || price.max_resale_price === ''
            ? undefined
            : Number(price.max_resale_price);

        return {
          ...price,
          raw_geo: price.geo,
          geo: formatGeoName(price),
          product: price.product?.display_name || '--',
          average_price: averagePriceValue === undefined || Number.isNaN(averagePriceValue)
            ? undefined
            : formatCurrency(averagePriceValue),
          min_price: minPriceValue === undefined || Number.isNaN(minPriceValue)
            ? undefined
            : formatCurrency(minPriceValue),
          max_price: maxPriceValue === undefined || Number.isNaN(maxPriceValue)
            ? undefined
            : formatCurrency(maxPriceValue)
        };
      })
    );
  }
}
